export default function Location() {
  return (
    <section id="location" className="py-12 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            오시는 길
          </h2>
          <p className="text-base md:text-lg text-gray-600 px-4">
            씽크짐창의융합놀이센터로 오시는 길을 안내해드립니다
          </p>
        </div>

        <style>{`
          @keyframes float3d {
            0%, 100% { transform: translateY(0px) rotateY(0deg) scale(1); }
            25% { transform: translateY(-4px) rotateY(15deg) scale(1.05); }
            50% { transform: translateY(-7px) rotateY(0deg) scale(1.08); }
            75% { transform: translateY(-4px) rotateY(-15deg) scale(1.05); }
          }
          @keyframes float3d-delay1 {
            0%, 100% { transform: translateY(0px) rotateY(0deg) scale(1); }
            25% { transform: translateY(-5px) rotateY(-15deg) scale(1.06); }
            50% { transform: translateY(-8px) rotateY(0deg) scale(1.09); }
            75% { transform: translateY(-5px) rotateY(15deg) scale(1.06); }
          }
          @keyframes float3d-delay2 {
            0%, 100% { transform: translateY(0px) rotateY(0deg) scale(1); }
            25% { transform: translateY(-3px) rotateY(20deg) scale(1.04); }
            50% { transform: translateY(-6px) rotateY(0deg) scale(1.07); }
            75% { transform: translateY(-3px) rotateY(-20deg) scale(1.04); }
          }
          @keyframes glow-pulse {
            0%, 100% { box-shadow: 0 8px 25px rgba(251,146,60,0.3), 0 0 0 0 rgba(251,146,60,0.2); }
            50% { box-shadow: 0 12px 35px rgba(251,146,60,0.5), 0 0 20px 5px rgba(251,146,60,0.15); }
          }
          @keyframes glow-pulse-blue {
            0%, 100% { box-shadow: 0 8px 25px rgba(99,102,241,0.3), 0 0 0 0 rgba(99,102,241,0.2); }
            50% { box-shadow: 0 12px 35px rgba(99,102,241,0.5), 0 0 20px 5px rgba(99,102,241,0.15); }
          }
          @keyframes glow-pulse-green {
            0%, 100% { box-shadow: 0 8px 25px rgba(34,197,94,0.3), 0 0 0 0 rgba(34,197,94,0.2); }
            50% { box-shadow: 0 12px 35px rgba(34,197,94,0.5), 0 0 20px 5px rgba(34,197,94,0.15); }
          }
          .icon-3d-pin {
            animation: float3d 3s ease-in-out infinite, glow-pulse 3s ease-in-out infinite;
          }
          .icon-3d-car {
            animation: float3d-delay1 3.5s ease-in-out infinite, glow-pulse-blue 3.5s ease-in-out infinite;
          }
          .icon-3d-bus {
            animation: float3d-delay2 4s ease-in-out infinite, glow-pulse-green 4s ease-in-out infinite;
          }
          .icon-inner {
            transition: transform 0.3s ease;
          }
          .icon-wrapper:hover .icon-inner {
            transform: scale(1.2) rotateY(30deg);
          }
        `}</style>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          <div className="flex flex-col gap-4 md:gap-5 md:col-span-1">
            <div className="rounded-2xl overflow-hidden shadow-xl h-[300px] md:h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C+%EA%B0%95%EB%82%A8%EA%B5%AC+%EC%84%A0%EB%A6%89%EB%A1%9C132%EA%B8%B8+28&zoom=17&language=ko"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="씽크짐창의융합놀이센터 위치"
              ></iframe>
            </div>
          </div>

          <div className="md:col-span-2 flex flex-col gap-4 md:gap-5">
            <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg flex-1 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
                <div className="icon-wrapper w-12 h-12 md:w-14 md:h-14 flex items-center justify-center" style={{ perspective: '200px' }}>
                  <div
                    className="icon-3d-pin icon-inner w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center"
                    style={{
                      background: 'linear-gradient(135deg, #ff9a56 0%, #ff6b35 50%, #e84d1c 100%)',
                      boxShadow: '0 8px 25px rgba(251,146,60,0.4), inset 0 1px 0 rgba(255,255,255,0.3)',
                    }}
                  >
                    <i className="ri-map-pin-2-fill text-white text-xl md:text-2xl" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}></i>
                  </div>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900">주소</h3>
              </div>
              <p className="text-gray-700 mb-2 text-sm md:text-base">서울특별시 강남구 선릉로132길 28</p>
              <p className="text-gray-500 text-xs md:text-sm">강남구청역 4번 출구에서 도보 3분</p>
            </div>

            <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg flex-1 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
                <div className="icon-wrapper w-12 h-12 md:w-14 md:h-14 flex items-center justify-center" style={{ perspective: '200px' }}>
                  <div
                    className="icon-3d-car icon-inner w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center"
                    style={{
                      background: 'linear-gradient(135deg, #a78bfa 0%, #7c3aed 50%, #5b21b6 100%)',
                      boxShadow: '0 8px 25px rgba(99,102,241,0.4), inset 0 1px 0 rgba(255,255,255,0.3)',
                    }}
                  >
                    <i className="ri-car-fill text-white text-xl md:text-2xl" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}></i>
                  </div>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900">주차 안내</h3>
              </div>
              <p className="text-gray-700 text-sm md:text-base mb-2">언북초 공영주차장 / 선릉로 132길 노상공영주차장.</p>
              <p className="text-gray-500 text-xs md:text-sm"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
